import { Faces } from './faces';


export class Procedimentos {
    constructor(
        public linha?: number,
        public codigo?: string,
        public descricao?: string,
        public denteArea?: string,
        public status?: string,
        public dataRealizacao?: Date,
        public dataConfirmacao?: Date,
        public faces?: Array<Faces>,
        public glosas?: any,
        public permiteConfirmar?: 'S' | 'N',
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/components/base/vo/procedimentos.ts